import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import Setting from 'modules/complaints/store/models/Setting'

type UpsertParams = {
  system_and_defense_custom_url: string
  privacy_policy_custom_url: string
}
class Settings extends Collection<Setting> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  get cacheKey(): string {
    return 'complaintsSettings'
  }

  model() {
    return Setting
  }

  get current(): Setting | undefined {
    return this.models[0]
  }

  upsert(data: UpsertParams) {
    return this.rpc('upsert', data)
  }
}

const singleton: Settings = new Settings()

export default singleton
